module.exports = __webpack_public_path__ + "img/fruits_bottom@2x.7b19e72a.png";